import React, { Fragment } from 'react';
import { IRepeaterFieldInputProps } from '.';
import { FormFieldType } from '../../dynamic-form/types/inputTypes';
import PercentageFormField from '../PercentageFormField';
import AutocompleteFormField from '../AutocompleteFormField';
import { IPagination } from '@models';
import SplitPrefixFormField from '../SplitPrefixFormField';
import TextInputFormField from '../TextInputFormField';

const RepeaterBoxInputField: React.FC<IRepeaterFieldInputProps> = ({
  value,
  rowIndex,
  error,
  autocompleteKey,
  touched,
  disabled,
  onFieldChange,
  onFieldBlur,
  onAutocompleteSearch,
  loading,
  input,
}) => {
  let title = input.title;
  const length = input?.dynamicTitle?.length;
  if (length > 0 && rowIndex < length) {
    title = input.dynamicTitle[rowIndex];
  }
  switch (input.type) {
    case FormFieldType.percentage:
      return (
        <PercentageFormField
          key={`${input.name}-${rowIndex}`}
          name={input.name}
          title={title}
          placeholder={input.placeholder}
          value={value}
          error={touched ? error : ''}
          loader={loading}
          disabled={input.disabled || disabled}
          material={input.material}
          onChange={(event) => {
            const value = event.target.value;
            onFieldChange(input.name, value, rowIndex);
          }}
          onBlur={() => {
            onFieldBlur(input.name, rowIndex);
          }}
        />
      );
    case FormFieldType.splitPrefix:
      return (
        <SplitPrefixFormField
          name={input.name}
          title={title}
          placeholder={input.placeholder}
          value={value}
          prefixValue={input.prefixValue}
          inputType={input.inputType}
          disabled={input.disabled}
          error={touched ? error : ''}
          material={input.material}
          onChange={(event) => {
            const value = event.target.value;
            onFieldChange(input.name, value, rowIndex);
          }}
          onBlur={() => {
            onFieldBlur(input.name, rowIndex);
          }}
        />
      );
    case FormFieldType.text:
      return (
        <TextInputFormField
          name={input.name}
          title={input.title}
          placeholder={input.placeholder}
          value={value}
          disabled={input.disabled}
          onChange={(event) => {
            const value = event.target.value;
            onFieldChange(input.name, value, rowIndex);
          }}
          onBlur={() => {
            onFieldBlur(input.name, rowIndex);
          }}
          error={touched ? error : ''}
          material={input.material}
        />
      );

    case FormFieldType.autocomplete:
      return (
        <AutocompleteFormField
          key={`${autocompleteKey}${rowIndex}`}
          name={input.name}
          title={title}
          placeholder={input.placeholder}
          value={value}
          error={touched ? error : ''}
          disabled={disabled}
          material={input.material}
          maxItemsDisplayed={input.maxItemsDisplayed}
          initialOptions={input.initialOptions}
          canClearValue={input.canClearValue}
          loader={loading}
          onChange={(v) => {
            onFieldChange(input.name, v, rowIndex);
          }}
          onBlur={() => {
            onFieldBlur(input.name, rowIndex);
          }}
          fetchOptions={function (
            query: string,
            pagination: IPagination,
            hasDefaultValue?: boolean
          ): Promise<{
            options: Record<string, string>;
            totalCount: number;
          }> {
            if (onAutocompleteSearch) {
              return onAutocompleteSearch(
                input.name,
                query,
                pagination,
                hasDefaultValue
              );
            }

            return new Promise<{
              options: Record<string, string>;
              totalCount: number;
            }>((resolve) => {
              resolve({ options: {}, totalCount: 0 });
            });
          }}
        />
      );
    default:
      return (
        <Fragment key={input.name}>
          ERROR: {input.type} not implemented
        </Fragment>
      );
  }
};

export default RepeaterBoxInputField;
